
































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import AreaDetailApi from '@/app/model/api/areaDetailApi'
import AreaEditApi from '@/app/model/api/areaEditApi'
import AreaCreateApi from '@/app/model/api/areaCreateApi'
import AreaDeleteApi from '@/app/model/api/areaDeleteApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo
  }
})
export default class AreaCreate extends Vue {
  private areaId: string = ''
  private id: string = ''
  private areaData: any = {}
  private area: string = ''
  private afterWeedingHeight: number|null = 3
  private weedGrowths: any = [{
    start_month: 3,
    alarm_value: 50,
    max_height: 80,
    leave_days: 60,
    weed_growth_height: 1.33,
    weed_info: null
  },
  {
    start_month: 6,
    alarm_value: 50,
    max_height: 70,
    leave_days: 44,
    weed_growth_height: 1.59,
    weed_info: null
  },
  {
    start_month: 9,
    alarm_value: 40,
    max_height: 45,
    leave_days: 60,
    weed_growth_height: 0.75,
    weed_info: null
  },
  {
    start_month: 12,
    alarm_value: 25,
    max_height: 30,
    leave_days: 60,
    weed_growth_height: 0.5,
    weed_info: null
  }]
  private remarks: string = ''
  private timeStamp: number = 0
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private isError: any = {}
  /* 表示非表示 */
  private showLoading: boolean = true
  private editflag: boolean = false
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false

  created () {
    this.areaId = this.$route.params.area_id
    this.getAreaList()
  }

  // 半角数字、-、.以外入力制限
  private inputCheck (key1: string, key2: number, key3: string) {
    let before
    if (key1 === 'afterWeedingHeight') {
      before = String(this.afterWeedingHeight)
    } else {
      before = String(this.weedGrowths[key2][key3])
    }

    let tmp
    let after: any
    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^-.0-9]/g, '')
      tmp = tmp.split('').reverse().join('')
      tmp = tmp.replace(/-(?=.)|\.(?=.*\.)/g, '')
      after = tmp.split('').reverse().join('')
    }

    // 小数点以下OK
    if (key1 === 'afterWeedingHeight') {
      if (isNaN(parseFloat(after))) {
        this.afterWeedingHeight = null
      } else {
        this.afterWeedingHeight = parseFloat(after)
      }
    } else {
      if (isNaN(parseFloat(after))) {
        this.weedGrowths[key2][key3] = null
      } else {
        this.weedGrowths[key2][key3] = parseFloat(after)
      }
    }
  }

  private getAreaList () {
    (async () => {
      const routePath = this.$route.path
      if (routePath !== '/master/area/create') {
        this.editflag = true
      }

      if (this.editflag) {
        const result = await AreaDetailApi.getAreaDetail(this.areaId)
        if (result.isOk()) {
          this.areaData = result.getPayload()

          this.id = this.areaData.area_id
          this.area = this.areaData.area_name
          this.afterWeedingHeight = this.areaData.after_weeding_height
          this.weedGrowths = this.areaData.weed_growths
          this.remarks = this.areaData.remarks
          this.timeStamp = this.areaData.time_stamp

          this.showLoading = false
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      } else {
        this.showLoading = false
      }
    })()
  }

  private areaSave () {
    if (this.editflag) {
      this.areaEdit()
    } else {
      this.areaCreate()
    }
  }

  private async areaEdit () {
    if (!this.isAreaEdit()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    const bodyData = {
      area: {
        area_name: this.area,
        after_weeding_height: this.afterWeedingHeight,
        remarks: this.remarks,
        time_stamp: this.timeStamp
      },
      weed_growths: this.weedGrowths
    }

    const result = await AreaEditApi.doAreaEdit(this.$route.params.area_id, bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地域編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/area').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private async areaCreate () {
    /* バリデーションチェック */
    if (!this.isAreaEdit()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    const bodyData: any = {
      area: {
        area_name: this.area,
        after_weeding_height: this.afterWeedingHeight,
        remarks: this.remarks
      },
      weed_growths: this.weedGrowths
    }

    const result = await AreaCreateApi.doAreaCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地域登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/area').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  /* バリデーション */
  private isAreaEdit () {
    // リセット
    this.errorMessages = {}

    const areaNameFlag = Validator.validateInputAreaName('areaNameErrorMessage', this.area)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true

    // 除草後雑草丈
    if (this.afterWeedingHeight !== null) {
      if (!Number.isInteger(this.afterWeedingHeight)) {
        this.$set(this.errorMessages, 'afterWeedingHeightErrorMessage', '除草後雑草丈は整数で入力してください。')
        isError = false
        this.$set(this.isError, 'after-weed-height', true)
      } else if (this.afterWeedingHeight < 0 || this.afterWeedingHeight > 10) {
        this.$set(this.errorMessages, 'afterWeedingHeightErrorMessage', '除草後雑草丈は0以上10以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'after-weed-height', true)
      } else {
        this.$set(this.isError, 'after-weed-height', false)
      }
    } else {
      this.$set(this.errorMessages, 'afterWeedingHeightErrorMessage', '除草後雑草丈は必ず入力してください。')
      isError = false
      this.$set(this.isError, 'after-weed-height', true)
    }

    for (let i in this.weedGrowths) {
      const data = this.weedGrowths[i]
      // 警報値
      if (data.alarm_value !== null) {
        if (!Number.isInteger(data.alarm_value)) {
          this.$set(this.errorMessages, 'alarmValueErrorMessage', '警報値は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'alarm_value' + i, true)
        } else if (data.alarm_value < 0 || data.alarm_value > 300) {
          this.$set(this.errorMessages, 'alarmValueErrorMessage', '警報値は0以上300以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'alarm_value' + i, true)
        } else {
          this.$set(this.isError, 'alarm_value' + i, false)
        }
      } else {
        this.$set(this.errorMessages, 'alarmValueErrorMessage', '警報値は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'alarm_value' + i, true)
      }
      // 放置時高さ
      if (data.max_height !== null) {
        if (!Number.isInteger(data.max_height)) {
          this.$set(this.errorMessages, 'maxHeightErrorMessage', '')
          isError = false
          this.$set(this.isError, 'max_height' + i, true)
        } else if (data.max_height < 0 || data.max_height > 300) {
          this.$set(this.errorMessages, 'maxHeightErrorMessage', '放置時高さは整数で入力してください。')
          isError = false
          this.$set(this.isError, 'max_height' + i, true)
        } else {
          this.$set(this.isError, 'max_height' + i, false)
        }
      } else {
        this.$set(this.errorMessages, 'maxHeightErrorMessage', '放置時高さは必ず入力してください。')
        isError = false
        this.$set(this.isError, 'max_height' + i, true)
      }
      // 放置日数
      if (data.leave_days !== null) {
        if (!Number.isInteger(data.leave_days)) {
          this.$set(this.errorMessages, 'leaveDaysErrorMessage', '放置日数は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'leave_days' + i, true)
        } else if (data.leave_days < 0 || data.leave_days > 200) {
          this.$set(this.errorMessages, 'leaveDaysErrorMessage', '放置日数は0以上200以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'leave_days' + i, true)
        } else {
          this.$set(this.isError, 'leave_days' + i, false)
        }
      } else {
        this.$set(this.errorMessages, 'leaveDaysErrorMessage', '放置日数は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'leave_days' + i, true)
      }
      // 雑草成長丈
      if (data.weed_growth_height !== null) {
        let decimalPointLength = String(data.weed_growth_height).split('.')
        if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 2) {
          this.$set(this.errorMessages, 'weedGrowthHeightErrorMessage', '雑草成長丈は小数点第2位までの範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'weed_growth_height' + i, true)
        } else {
          this.$set(this.isError, 'weed_growth_height' + i, false)
        }
      } else {
        this.$set(this.errorMessages, 'weedGrowthHeightErrorMessage', '雑草成長丈は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'weed_growth_height' + i, true)
      }
      // 対象雑草名等
      if (data.weed_info !== null && data.weed_info !== undefined) {
        if ([...data.weed_info].length > 100) {
          this.$set(this.errorMessages, 'weedInfo', '対象雑草名等は100文字以下で入力してください。')
          isError = false
          this.$set(this.isError, 'weed_info' + i, true)
        } else {
          this.$set(this.isError, 'weed_info' + i, false)
        }
      }
    }

    return areaNameFlag && isError
  }

  /* 地域削除 */
  private doAreaDelete () {
    (async () => {
      const result = await AreaDeleteApi.doAreaDelete(this.$route.params.area_id.toString())

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地域を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/area').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  private doCancel () {
    this.$router.push('/master/area').catch(e => {})
  }

  // 雑草成長丈を計算
  private calculationWeedGrowthHeight (i: number) {
    if (this.weedGrowths[i].max_height !== null && this.weedGrowths[i].leave_days !== null) {
      // 雑草成長丈(cm/日)＝放置時高さ/放置日数(小数点第三位を四捨五入)
      const data = this.weedGrowths[i].max_height / this.weedGrowths[i].leave_days
      if (isNaN(data) || !isFinite(data)) {
        this.weedGrowths[i].weed_growth_height = 0
      } else {
        this.weedGrowths[i].weed_growth_height = Math.round(data * 100) / 100
      }
    } else {
      this.weedGrowths[i].weed_growth_height = null
    }
  }

  private judgeStartMonth (key: number) {
    switch (key) {
      case 3:
        return '3月～5月'

      case 6:
        return '6月～8月'

      case 9:
        return '9月～11月'

      default:
        return '12月～2月'
    }
  }
}
